import { render, staticRenderFns } from "./Cadastros.vue?vue&type=template&id=d966c1c6&scoped=true"
import script from "./Cadastros.vue?vue&type=script&lang=js"
export * from "./Cadastros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d966c1c6",
  null
  
)

export default component.exports